<template>
  <div class="page">
    <div class="form-page page-container">
      <template v-if="!showSuccess">
        <div class="intro" v-html="intro"></div>
        <h3>预约信息</h3>
        <div class="form">
          <a-form
            :layout="formLayout"
            :form="form"
            class="form-page-main"
            @submit="onSubmit"
          >
            <a-form-item
              label="乘客姓名"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请填写乘客姓名"
                size="large"
                v-decorator="[ 'passengerName', validatorRules.passengerName ]"
              />
            </a-form-item>
            <a-form-item
              label="预约航段"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select
                v-decorator="[ 'segId', validatorRules.segId ]"
                placeholder="请选择预约航段"
                size="large"
              >
                <a-select-option v-for="segment in segments" :value="segment.id" :key="segment.id">
                  {{ segment.departurePortName }} ({{ segment.departurePort }}) - {{ segment.arrivalPortName }} ({{ segment.arrivalPort }})
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              label="期望出行时间"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-month-picker
                placeholder="请选择期望出行时间"
                size="large"
                :disabledDate="startDisabledDate"
                v-decorator="[ 'reservMonth', validatorRules.reservMonth ]"
              /> <br />
            </a-form-item>
            <a-form-item
              label="联系人姓名"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                size="large"
                placeholder="请填写联系人姓名"
                v-decorator="[ 'contactName', validatorRules.contactName ]"
              />
            </a-form-item>
            <a-form-item label="联系人手机号" >
              <a-input
                size="large"
                placeholder="请填写联系人手机号"
                v-decorator="[ 'phone', validatorRules.phone ]"
              >
                <a-select
                  slot="addonBefore"
                  :options="areaCodeOptions"
                  @change="onAreaCodeChange"
                  key='label'
                  option-label-prop="title"
                  v-decorator="[ 'areaCode', validatorRules.areaCode ]"
                >
                </a-select>
              </a-input>
            </a-form-item>
            <div class="action flex-hb-vc">
              <a-button type="primary" size="large" class="full-btn" :loading="loading" html-type="submit"> 提交预约 </a-button>
            </div>
          </a-form>
        </div>
        <div class="tips" v-html="tips"></div>
      </template>
      <success v-if="showSuccess"></success>
    </div>
  </div>
</template>
<script>
import { fetchGjpReservSegList, submitGjpReservPlace } from '@/apis/customized'
import moment from 'moment'
import Success from './components/Success.vue'
import areaCodeOptions from '@/assets/js/areacode'
import './index'

export default {
  components: { Success },
  data () {
    return {
      form: this.$form.createForm(this),
      validatorRules: {
        passengerName: {
          rules: [{ required: true, message: '请填写乘客姓名' }]
        },
        segId: {
          rules: [{ required: true, message: '请选择预约航段' }]
        },
        reservMonth: {
          rules: [{ type: 'object', required: true, message: '请选择期望出行时间' }]
        },
        contactName: {
          rules: [{ required: true, message: '请填写联系人姓名' }]
        },
        phone: {
          rules: [{ required: true, message: '请填写联系人手机号' }, { pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号' }]
        },
        areaCode: {
          initialValue: '86', rules: [{ required: true }]
        }

      },
      intro: `
      <p>
        祥鹏航空现已开放国际航班的购票预约服务，如您有意愿申请，请填写下表，我们将根据航班可利用座位情况通知您进行客票预定。
      </p>`,
      tips: `
      <p>温馨提示：</p>
      <p>因各个国家和地区对持不同旅行证件的旅客,均有不同的过境或入境要求,为了您的旅行顺畅,请在购买国际客票之前,向相关大使馆或出入境管理部门先行了解详尽的过境或入境要求。</p>`,
      isMobile: false,
      formLayout: 'horizontal',
      loading: false,
      showSuccess: false,
      segments: [],
      areaCode: '86',
      resultData: {},
      areaCodeOptions
    }
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 4 },
          wrapperCol: { span: 14 }
        }
        : {}
    }
  },
  created () {
    this.formLayout = this.isMobile === true ? 'horizontal' : 'vertical'
    this.getSegList()
  },
  methods: {
    onAreaCodeChange (value) {
      // areaCode为86才校验手机号码格式
      this.validatorRules.phone.rules = value !== '86' ? [{ required: true, message: '请填写联系人手机号' }] : [{ required: true, message: '请填写联系人手机号' }, { pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号' }]
      this.$nextTick(() => {
        this.form.validateFields(['phone'], { force: true })
      })
    },
    goToHome () {
      this.$emit('goToHome')
    },
    startDisabledDate (current) {
      return current && (current < moment().startOf('month') || current > moment().add(6, 'months'))
    },
    getSegList () {
      fetchGjpReservSegList({}).then(result => {
        this.segments = result || []
      }).catch(e => {
        this.$message.error(e.message)
      })
    },
    onSubmit (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((errors, values) => {
        if (!errors) {
          const params = {
            segId: values.segId,
            reservMonth: moment(values.reservMonth).format('YYYY-MM-01'),
            passengerName: values.passengerName,
            contactName: values.contactName,
            contactMobile: values.phone,
            contactAddr: values.areaCode
          }
          submitGjpReservPlace(params).then(result => {
            this.resultData = result
            this.loading = false
            this.showSuccess = true
          }).catch(e => {
            this.loading = false
            this.$message.error(e.message)
          })
        } else {
          this.loading = false
        }
      })
    }
  }
}
</script>
